import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../context/AuthContext";

let deferred = null; const subs = new Set();
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; subs.forEach(f => f()); track("prompt_available"); });
  window.addEventListener("appinstalled", () => { deferred = null; localStorage.setItem("rl_pwa_installed", "1"); subs.forEach(f => f()); track("appinstalled"); });
}
export const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;
export const isMobile = () => /android|iphone|ipad|ipod/i.test(navigator.userAgent);
export const deviceInfo = () => { const ua = navigator.userAgent; return { os: isIOS() ? "iOS" : /android/i.test(ua) ? "Android" : /win/i.test(ua) ? "Windows" : /mac/i.test(ua) ? "macOS" : "altro", browser: /samsungbrowser/i.test(ua) ? "Samsung Internet" : /edg/i.test(ua) ? "Edge" : /chrome|crios/i.test(ua) ? "Chrome" : /safari/i.test(ua) ? "Safari" : /firefox/i.test(ua) ? "Firefox" : "altro", standalone: isStandalone() }; };
export function track(event) { try { axios.post(`${API}/pwa/events`, { event, ...deviceInfo() }).catch(() => {}); } catch {} }
if (typeof window !== "undefined" && isStandalone() && !sessionStorage.getItem("rl_pwa_open")) { sessionStorage.setItem("rl_pwa_open", "1"); track("standalone_open"); }

export function useInstall() {
  const [, force] = useState(0);
  useEffect(() => { const f = () => force(x => x + 1); subs.add(f); return () => subs.delete(f); }, []);
  const installed = isStandalone() || localStorage.getItem("rl_pwa_installed") === "1";
  const canPrompt = !!deferred;
  const prompt = async () => {
    if (!deferred) return "unavailable";
    track("install_click"); deferred.prompt(); track("prompt_shown");
    const r = await deferred.userChoice; deferred = null; subs.forEach(f => f());
    track(r.outcome === "accepted" ? "install_accepted" : "install_dismissed");
    return r.outcome;
  };
  return { installed, canPrompt, prompt, ios: isIOS(), mobile: isMobile(), standalone: isStandalone() };
}
